<style>
#treeviewcuentacontable li {
  font-size: 1rem !important;
  cursor: pointer;
}

#treeviewcuentacontable li span:hover {
  text-decoration: underline;
}
</style>
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Polizas Contables</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                :to="{ name: 'con-polizas-contables-nuevo', params: {} }"
                class="btn btn-sm btn-success"
              >
                <i class="fas fa-plus"></i> Nueva Poliza</router-link
              >
            </div>
            <div class="row col-12 justify-content-sm-end">
              <div class="col-2">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
              </div>
              <div class="col-2">
                <input
                  v-on:keyup.enter="filterData()"
                  class="form-control form-control-sm rounded bright"
                  placeholder="Número"
                  v-model="filter.numero"
                  type="text"
                />
              </div>
              <div>
                <select
                  @change="filterData()"
                  class="form-control text-center rounded bright"
                  v-model="filter.estado"
                >
                  <option value="">estado</option>
                  <option value="A">abierto</option>
                  <option value="B">cerrado</option>
                  <option value="9">anulado</option>
                </select>
              </div>
              &nbsp; &nbsp;
              <div class="input-group-append">
                <button class="btn btn-link btn-sm" @click="filterData()">
                  <i class="fa fa-search"></i>
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  v-on:click="clearFilterData()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <!-------------------- Tabla de REsultados -------------------->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Número</th>
                <th class="text-center">Tipo</th>
                <th class="text-center">Fecha</th>
                <th class="text-center">Descripción</th>
                <th class="text-center">Ref.</th>
                <th class="text-right">Cargos</th>
                <th class="text-right">Abonos</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="
                  irAEsconderModal('con-polizas-contables-editar', {
                    id: current.id,
                  })
                "
              >
                <td class="text-center">{{ current.numero }}</td>
                <td class="text-center">
                  {{ current.tipo_poliza_obj.nombre }}
                </td>
                <td class="text-center">{{ current.fecha }}</td>
                <td>{{ current.descripcion }}</td>
                <td class="text-center">{{ current.docto_ref }}</td>
                <td class="text-right">{{ current.cargos }}</td>
                <td class="text-right">{{ current.abonos }}</td>
                <td class="text-center">
                  <div class="icon-w text-center">
                    <div
                      v-if="current.estado == 'A'"
                      style="color: green"
                      class="fa fa-unlock"
                    ></div>
                    <div
                      v-if="current.estado == 'B'"
                      style="color: orange"
                      class="fa fa-lock"
                    ></div>
                    <div
                      v-if="current.estado == '9'"
                      style="color: red"
                      class="fa fa-archive"
                    ></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import PaginationComponent from "@/components/utils/PaginationComponent";
import PolizasContablesServices from "@/services/conta/PolizasContablesServices";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      data: [],
      filter: {
        estado: "",
        numero: "",
      },
      open: true,
    };
  },
  computed: {},
  mounted() {
    self.verArbol = true;
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        numero: this.filter.numero,
        estado: this.filter.estado,
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.filter.numero = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tienda: this.filterActiva,
      });
    },
    refreshData(params) {
      let self = this;
      PolizasContablesServices.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() {},
    verArbol() {
      let self = this;
      self.refreshData();
    },
    openclose() {
      this.open = !this.open;
    },
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
